export default __webpack_public_path__ + "static/media/Quimby.bf182559.png";